module.exports = __webpack_public_path__ + "img/email.42b495f0.svg";